<div class="ttmodal" >
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Shoe Infomation" | translate | async }}
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body" >

    
    <div>
      <mat-form-field >
        <mat-select name="size"  placeholder="Shoe Size" [(ngModel)]="ShoeSize" >
            <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
        </mat-select>
    </mat-form-field>
    </div>

    <div>
      <mat-form-field >
        <mat-select name="grouser"  placeholder="Grouser" [(ngModel)]="GrouserId">
            <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
        </mat-select>
    </mat-form-field>
    </div>

    <div>
      <mat-form-field >
                                                              
        <mat-select name="cleanerholes" placeholder="Cleaner Holes"  [(ngModel)]="CleanerHolesId" >
          <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
      </mat-select>
    </mat-form-field>
    </div>

    
  </div>

  
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn" (click)="Save()" ><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Submit' | translate | async }} </span></button>
   
  </div>
</div>